import { useCallback, useEffect, useState } from "react";
import IFilterPromotion from "../interface/IFilterPromotion.interface";
import { ResponsePromotionTYpe, ResponsePromotions } from "../interface/promotion.interface";
import promotionService from "../promotionService";
import IFilterPromotionByType from "../interface/IFilterPromotionByType.interface";

const useGetPromotionByType = (filters: IFilterPromotionByType, code: string, enabled = true) => {
  const [data, setData] = useState<ResponsePromotionTYpe>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return promotionService.promotionGetByType(code, filters);
  }, [filters]);

  const transformResponse = useCallback((response: ResponsePromotionTYpe) => {
    if (response) {
      setData(response);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useGetPromotionByType;
